import { ApplicationState, AppThunkDispatch } from "../../store";
import { connect } from "react-redux";
import ClientForm  from "../../components/Forms/ClientForm";
import { ClientEntity } from "../../store/entities/state";
import { getChangingState, getChangingValue, isSubmittingNew } from "../../store/entities/selectors";
import { createEntity, entityCreatingCancel, updateChangingEntity } from "../../store/entities/actions";
import { createClientAsync } from "../../ajax/requests";
import { ClientFormDispatchProps, ClientFormStateProps } from "../../components/Forms/ClientForm/ClientForm";
import { canEditClients } from "../../store/session/selectors";

const mapStateToProps = (state: ApplicationState): ClientFormStateProps => ({
    type: 'create',
    canManageClients: canEditClients(state),
    data: getChangingValue(state, 'clients') as ClientEntity,
    hasChanged: getChangingState(state, 'clients'),
    isSubmitting: isSubmittingNew(state, 'clients'),
})

const mapDispatchToProps = (dispatch: AppThunkDispatch): ClientFormDispatchProps => ({
    onChange: (data: ClientEntity) => dispatch(updateChangingEntity('clients', data)),
    onCancel: () => dispatch(entityCreatingCancel('clients')),
    onSave: (data: ClientEntity) => dispatch(createEntity('clients', data, c => createClientAsync(c))),
});

export default connect<ClientFormStateProps, ClientFormDispatchProps, unknown, ApplicationState>(
    mapStateToProps,
    mapDispatchToProps,
)(ClientForm as any);